import integrationUtils from '../../../../../Utils/integration.utils';
import ArrowEnterIcon from '../../../../icons/arrow-enter.icon';
import CalendarIcon from '../../../../icons/calendar.icon';
import "./current-tool-row.styles.scss";

const ToolLicenseRow = ({ license }) => {
  return (
    <tr className="tool-license-row">
      <td>
        <div className="flex items-center gap-8">
          <ArrowEnterIcon width={12} height={12} />
          {license?.ProductName?.length > 20 ? `${license?.ProductName?.slice(0, 20)}...` : license?.ProductName}
        </div>
      </td>
      <td>{license?.Quantity}</td>
      <td>
        <div className="flex items-center gap-8">
          <CalendarIcon className="f-darkgrey" />
          {license?.ContractEndDate && license?.ContractEndDate != '' ? license?.ContractEndDate : 'Not selected'}
        </div>
      </td>
      <td>{license?.Cost}</td>
      <td>{license?.TotalText}</td>
    </tr>
  );
};

const CurrentToolRow = ({ tool }) => {
  return (
    <>
      <tr className="current-tool-row">
        <td>
          <div className="flex items-center gap-8">
            <img
              className="tool-icon"
              width="14"
              height="14"
              src={integrationUtils.getImagePath(tool?.ToolId, tool?.ToolIcon)}
              alt={tool?.ToolName}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = "/images/attack-surface/generic2.svg";
              }}
            />
            <span>{tool?.ToolName}</span>
          </div>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      {tool?.SecurityStackReportToolProduct_List?.map((license, index) => (
        <ToolLicenseRow key={`${tool.ToolName}-license-${index}`} license={license} />
      ))}
    </>
  );
};

export default CurrentToolRow;
